import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Select, Input } from "antd";
import { updateInvoiceStatus } from "../../services/invoiceService";
import {
  getInvoiceStatusOptions,
  getPaymentMethodOptions,
} from "../../constants/invoiceConstants";
import { toast } from "react-toastify";

const { TextArea } = Input;

const InvoiceStatusModal = ({ visible, invoice, onCancel, onSuccess }) => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const selectedStatus = Form.useWatch("status", form);

  useEffect(() => {
    if (visible) {
      form.resetFields();
    }
  }, [visible, form]);

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      setLoading(true);

      await updateInvoiceStatus(
        invoice.id,
        values.status,
        values.paymentMethod
      );
      toast.success("Fatura durumu güncellendi");
      onSuccess();
    } catch (error) {
      if (!error.errorFields) {
        console.error("Error updating invoice status:", error);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title="Fatura Durumu Değiştir"
      open={visible}
      onCancel={onCancel}
      maskClosable={false}
      footer={[
        <Button key="cancel" onClick={onCancel} disabled={loading}>
          İptal
        </Button>,
        <Button
          key="submit"
          type="primary"
          loading={loading}
          onClick={handleSubmit}
        >
          Güncelle
        </Button>,
      ]}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="status"
          label="Yeni Durum"
          rules={[{ required: true, message: "Lütfen bir durum seçin" }]}
        >
          <Select
            placeholder="Durum seçin"
            options={getInvoiceStatusOptions()}
          />
        </Form.Item>

        {selectedStatus === "PAID" && (
          <Form.Item
            name="paymentMethod"
            label="Ödeme Yöntemi"
            rules={[{ required: true, message: "Lütfen ödeme yöntemi seçin" }]}
          >
            <Select
              placeholder="Ödeme yöntemi seçin"
              options={getPaymentMethodOptions()}
            />
          </Form.Item>
        )}
      </Form>
    </Modal>
  );
};

export default InvoiceStatusModal;
